import { useFetchQuery } from "common/queries/hooks";

import { DashboardSummary } from "../types";
import { keys, urls } from "./constants";

export const useSummaryQuery = () => {
  return useFetchQuery<DashboardSummary>(keys.summary(), {
    fetch: { url: urls.summary() },
  });
};
